import { ApiService } from './api-services';

export default class GlossaryService {
	static baseUrl = ['/api/glossary'];

	static async getGlossary() {
		const res = await ApiService.get(
			`${GlossaryService.baseUrl[0]}/get-all-glossary`
		);
		return res;
	}

	static async addGlossary(data) {
		const res = await ApiService.post(
			`${GlossaryService.baseUrl[0]}/add-glossary`,
			data
		);
		return res;
	}

	static async addGlossaryEntries(data) {
		const res = await ApiService.post(
			`${GlossaryService.baseUrl[0]}/add-bulk-glossary`,
			data
		);
		return res;
	}

	static async delGlossary(data) {
		const res = await ApiService.delete(
			`${GlossaryService.baseUrl[0]}/delete-glossary/${data}`
		);
		return res;
	}

	static async updateGlossary(data) {
		const res = await ApiService.put(
			`${GlossaryService.baseUrl[0]}/update-glossary`,
			data
		);
		return res;
	}
}
